<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Mi equipo
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close


    .body
      .message.is-info(v-if="isShowingJefeDirecto")
        .message-body
          strong *
          span Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad aprobar las solicitudes&nbsp;
          span de vacaciones de ellos.
      .is-desktop
        table.table.is-bordered
          thead
            th Empleado
            th Fecha Ingreso
            th(v-if="isShowingJefeDirecto") Jefe directo
            th Días por tomar / programar
            th.td-status
          tbody(
            name="table-row"
            is="transition-group"
          )
            tr.row-table(
              v-for="(o,index) in equipo"
              :key="index+'-desktop'"
              :class="{ directo: o.directo, 'row-info':o.esDeDelegacion, 'fw-bold': o.codigoJefe === +codigoLogueadoJefe }"
            )
              td
                .flex.aic
                  span.hint--top.margin-right-5(:aria-label="'Equipo Delegado'",v-if="o.esDeDelegacion")
                    i.fa.fa-exclamation-circle
                  .hint--bottom(:aria-label="'Empleado: ' + o.dni")
                    span.name {{ o.nombre }}
                    br
                    span.email  ({{ o.cargo }})
              td {{ o.fechaIngreso }}
              td(v-if="isShowingJefeDirecto")
                .hint--top(:aria-label="'Jefe: ' + o.dniJefe")
                  | {{ o.nombreJefe }}
              td {{ o.diasReales }} / {{ o.diasDisponibles }}
              td.td-status
                .status
                  .circle(
                    :class=`{
                      'yellow' : o.diasReales >= 35 && o.diasReales <= 40,
                      'red' : o.diasReales > 40
                    }`
                  )
      .is-mobile
        .box.has-text-left(
            v-for="(o, index) in equipo"
            :key="index+'-mobile'"
            :class="{ directo: o.directo, 'row-info':o.esDeDelegacion, 'fw-bold': o.codigoJefe === +codigoLogueadoJefe }"
          )
          .dias
            span
              strong {{ o.diasReales }}&nbsp;
              span por tomar /&nbsp;
              strong {{ o.diasDisponibles }}&nbsp;
              span por programar&nbsp;
            .status
              .circle(
                :class=`{
                  'yellow' : o.diasReales >= 35 && o.diasReales <= 40,
                  'red' : o.diasReales > 40
                }`
              )
          .flex.aic
            span.hint--top.margin-right-5(:aria-label="'Equipo Delegado'",v-if="o.esDeDelegacion")
              i.fa.fa-exclamation-circle
            .mt-10.hint--bottom(:aria-label="'Empleado: ' + o.dni")
              span.name {{ o.nombre }}
          div
            span.text-small Cargo:&nbsp;
            span {{ o.cargo }}
          div
            span.text-small Fecha de Ingreso:&nbsp;
            span {{ o.fechaIngreso }}
          div.hint--top(v-if="codigoLogueadoJefe !== (o.codigoJefe + '')", :aria-label="'Jefe: ' + o.dniJefe")
            span.text-small Jefe:&nbsp;
            span {{ o.nombreJefe }}
      loading(v-if="isLoading")


</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'lista_equipo_vacaciones_component',
  data () {
    return {
      equipo: [],
      codigoLogueadoJefe:localStorage.getItem('codigo') + '',
      isLoading: false,
      isShowingJefeDirecto: true
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/vacaciones/empleado/equipo/cascada', obj, function (data) {
        vm.equipo = data.lista
        let contador = 0
        // validacion para verificar si el codigo del jefe logueado es igual al codigo del jefe del array entero
        vm.equipo.forEach(function (element, index) {
          if (vm.codigoLogueadoJefe === (element.codigoJefe + '')) {
            contador += 1
          }
        })
        if (contador === vm.equipo.length) {
          vm.isShowingJefeDirecto = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fw-bold
    font-weight bold !important
  .contenedor-interno
    .close
      float right
      cursor pointer
      position: absolute
      top: 3px
      right: 3px
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px

  .row-table
    transition all 0.3s ease

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }



  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000

  .directo
    font-weight: bold;

    &:hover
      font-weight: bold;

  td
    vertical-align: middle;
    .email
      font-size 12px
      color #9a9a9a

  .is-mobile
    display none
    .box
      position: relative
  .text-small
    font-size 12px
    color #9a9a9a
  @media (max-width 650px)
    .is-mobile
      display block


    .is-desktop
      display none

    .dias
      display flex
      position: absolute
      top: 3px
      right: 6px
      align-items: center
      .status
        .circle
          width: 15px;
          height: 15px;

    .name
      font-size: 16px;


</style>



// WEBPACK FOOTER //
// Component_Lista_Equipo_Vacaciones.vue?4631239b